/** * * Asynchronously loads the component for
MenuManagement
* */ import { lazyLoad } from 'utils/loadable';
export const MenuManagement = lazyLoad(() => import('./index'));
